import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
// import HomeView from "@/views/Home.vue"
// import Inventory from "@/views/Inventory.vue"
// import Withdraw from "@/views/Withdraw.vue"
// import ReferralProgram from "@/views/ReferralProgram.vue"
// import Leaderboard from "@/views/Leaderboard.vue"
// import CoinFlip from "@/views/CoinFlip.vue"
// import Referral from "@/views/Referral.vue"
// import WheelOfFortune from "@/views/wheel-of-fortune/WheelOfFortune.vue"
// import Rounds from "@/views/wheel-of-fortune/Rounds.vue"
// import Round from "@/views/wheel-of-fortune/Round.vue"
// import Settings from "@/views/Settings.vue"
// import Support from "@/views/Support.vue"
// import Admin from "@/views/admin/index.vue"
// import Giveaways from "@/views/Giveaways.vue"
// import GameHistory from "@/views/GameHistory.vue"
// import Callback from "@/views/Callback.vue"
import store from "@/store"
import { callApi } from "@/services/api"
// import Mm2Items from "@/views/admin/mm2Items.vue"
// import AdminLeaderboard from "@/views/admin/AdminLeaderboard.vue"

export const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/inventory",
    name: "inventory",
    meta: { requiresAuth: true },
    component: () => import("@/views/Inventory.vue"),
  },
  {
    path: "/inventory/withdraw",
    name: "withdraw",
    component: () => import("@/views/Withdraw.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/referral-program",
    name: "referral-program",
    component: () => import("@/views/ReferralProgram.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/leaderboard",
    name: "leaderboard",
    component: () => import("@/views/Leaderboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/Settings.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/support",
    name: "support",
    component: () => import("@/views/Support.vue"),
  },
  {
    name: "coin-flip",
    path: "/coin-flip/games/:gameSlug/rounds",
    component: () => import("@/views/CoinFlip.vue"),
    // meta: { requiresAuth: true },
  },
  {
    name: "referral",
    path: "/referral/:referralCode",
    component: () => import("@/views/Referral.vue"),
    meta: { requiresNoAuth: true },
  },
  {
    name: "wheel-of-fortune",
    path: "/wheel-of-fortune/games/:gameSlug/rounds",
    component: () => import("@/views/wheel-of-fortune/WheelOfFortune.vue"),
    children: [
      {
        path: "",
        name: "wheel-of-fortune.rounds",
        component: () => import("@/views/wheel-of-fortune/Rounds.vue"),
        // meta: { requiresAuth: true },
      },
      {
        path: ":roomId",
        name: "round",
        component: () => import("@/views/wheel-of-fortune/Round.vue"),
        // meta: { requiresAuth: true },
      },
    ],
    // meta: { requiresAuth: true },
  },
  {
    name: "upgrader",
    path: "/upgrader",
    component: () => import("@/views/Upgrader.vue"),
  },
  {
    name: "giveaways",
    path: "/giveaways",
    component: () => import("@/views/Giveaways.vue"),
    meta: { requiresAuth: true },
  },
  {
    name: "game-history",
    path: "/game-history",
    component: () => import("@/views/GameHistory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/callback",
    name: "callback",
    component: () => import("@/views/Callback.vue"),
  },
  {
    path: "/moderator-account",
    name: "me-moderator",
    component: () => import("@/views/moderator/ModeratorView.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/views/admin/index.vue"),
    children: [
      {
        path: "mm2-items",
        name: "admin.mm2-items",
        component: () => import("@/views/admin/mm2Items.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "leaderboard",
        name: "admin.leaderboard",
        component: () => import("@/views/admin/AdminLeaderboard.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "leaderboard/:id/edit",
        name: "admin.leaderboard.edit",
        component: () => import("@/views/admin/AdminLeaderboardEdit.vue"),
        meta: { requiresAdmin: true },
        props: true,
      },
      {
        path: "server-inventory",
        name: "admin.server-inventory",
        component: () => import("@/views/admin/ServerInventory.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "ban-words",
        name: "admin.ban-words",
        component: () => import("@/views/admin/BanWords.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "system-broadcasts",
        name: "admin.system-broadcasts",
        component: () => import("@/views/admin/SystemBroadcasts.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "moderators",
        name: "admin.moderators",
        component: () => import("@/views/admin/Moderators.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "banned-users",
        name: "admin.banned-users",
        component: () => import("@/views/admin/BannedUsers.vue"),
        meta: { requiresAdmin: true },
      },
      {
        path: "bot-management",
        name: "admin.bot-management",
        component: () => import("@/views/admin/Bots.vue"),
        meta: { requiresAdmin: true },
      },
    ],
    meta: { requiresAdmin: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to.meta.requiresAdmin) {
      await callApi.admin.checkIp()
      return next()
    }

    const fetchProfilePromise = store.getters[
      "auth/promiseFetchingProfile"
    ] as Promise<void> | null

    if (fetchProfilePromise) {
      await fetchProfilePromise
      store.commit("auth/SET_FETCHING_PROFILE", null)
    }

    // Auth / NoAuth checks
    const token = localStorage.getItem("access_token")

    if (to.meta.requiresAuth && !token) {
      store.commit("auth/SHOW_LOGIN_MODAL", true)
      store.commit("auth/SET_REDIRECT_AFTER_LOGIN", to.name)
      return next({ name: "home" }) // cancel navigation
    }

    if (to.meta.requiresNoAuth && token) {
      return next({ name: "home" })
    }

    return next()
  } catch (error) {
    // handle admin or other errors
    return next("/no-access")
  }
})

export default router
